import React, { useEffect, useRef, useState } from "react";
import "./SingleCase.less";
import { Avatar, Button, Spin, Empty } from "../../../BP2Components";
import {
   Icon_ArrowRight,
   Icon_CommentWithDots,
   Icon_RedirectToCase,
} from "../../../BP2Components/Icons/icons";
import { Link } from "react-router-dom";
import PlanMessageModal from "../../../Modal/PlanMessageModal/PlanMessageModal";
import { getLabelFromTechName } from "../../../Newsletter/NewsletterSteps/ThirdStep";
import { getMessageStep } from "../../../../services/api/Api";
import CommentsItem from "../../../Comments/CommentsItem";
import AddComments from "../../../Comments/AddComments";
import IntlMessages from "../../../../util/IntlMessages";
import { useDispatch, useSelector } from "react-redux";
import ScrollToBottom from "react-scroll-to-bottom";
import { useIntl } from "react-intl";
import moment from "moment";
import MessageButtonsDropdown from "../../MessageButtons/MessageButtonsDropdown/MessageButtonsDropdown";
import CaseImage from "./CaseImage/CaseImage";
import { useWindowSize } from "../../../../util/customHooks";
import { handleActionRestrictions } from "../../../Widgets/InfiniteListWidget/InfiniteListScripts";
//@ts-ignore
import projectConfig from "@projectConfig";
import clsx from "clsx";

import User from "./Union.svg";
import Group from "./group.svg";
import { TagsSection } from "./Tags/Tags";
import { useRegistryColorsContext } from "../../../../context/RegistryContexts/RegistryColorsContext";
import { getCaseStatus } from "../../../../util/getCaseStatus";
import ShowDate from "./ShowDate/ShowDate";
import MessageItemProvider from "../../../../context/MessageItemContext/MessageItemContext";
import { FormRefCurrent } from "../../../Widgets/InfiniteListWidget/FastActionsContext/types";
import { setUrlTo, isInNuxtContext } from "../../GeneralScripts";
import { LinkToCase } from "./LinkToCase/LinkToCase";
import { markMessageRead } from "../../../../services/restAPI/RestApi";
import { setBackUrl } from "../../../../appRedux/actions/Auth";

interface SingleCaseProps {
   singleCase: any;
   getCases?: (val: number) => void;
   setPageToDownload?: (val: number) => void;
   listResponse: any;
   actionCallback: () => void;
   value: any;
}

interface Step {
   actions: Array<any>;
   sysActions?: Record<string, any>;
}

const SingleCase: React.FC<SingleCaseProps> = ({
   singleCase,
   getCases,
   setPageToDownload,
   listResponse,
   actionCallback,
   value,
}) => {
   const { oldId: userId } = useSelector(({ user }: any) => user);
   const [step, setStep] = useState<Step>();
   const [comments, setComments] = useState([]);
   const [isLoading, setIsLoading] = useState(false);
   const [isTextAreaFocused, setIsTextAreaFocused] = useState(false);
   const [commentsVisible, setCommentsVisible] = useState(false);
   const { avatarLink } = useSelector(({ user }: any) => user);
   const { width: windowWidth } = useWindowSize();
   const registryColors = useRegistryColorsContext();
   const dispatch = useDispatch();
   const [hover, setHover] = useState(false);

   const formRef = useRef<FormRefCurrent | null>(null);

   const columns = listResponse?.columns;

   const mailBoxId = singleCase?.[getLabelFromTechName("mailBoxId", columns)];
   const actionId = singleCase[getLabelFromTechName("id", columns)];
   const keyInfo = singleCase[getLabelFromTechName("keyinfo_mh", columns)];
   const dueDate = singleCase[getLabelFromTechName("zajme", columns)];
   const title = singleCase[getLabelFromTechName("temat", columns)];
   const sender = singleCase?.[getLabelFromTechName("nadawca", columns)];

   const tags = singleCase[getLabelFromTechName("tagi", columns)];
   const deadlineDate = singleCase[getLabelFromTechName("deadline", columns)];
   const fromDate = singleCase[getLabelFromTechName("utworzono_data", columns)];
   const formattedFromDate = moment(fromDate).format("DD.MM.YYYY\u00A0\u00A0\u00A0HH:mm");
   const tagsToDisplay = Array.from(new Set(tags?.split(","))).filter(
      (text: any) => text.trim() !== "",
   ) as string[];
   const privateTags = singleCase[getLabelFromTechName("tagi_priv", columns)];
   const privateTagsToDisplay = Array.from(new Set(privateTags?.split(","))).filter(
      (text: any) => text.trim() !== "",
   ) as string[];
   const start = singleCase[getLabelFromTechName("zajme", columns)];
   const lockedDateAndTime = singleCase[getLabelFromTechName("blocked", columns)];
   const lockDate = singleCase[getLabelFromTechName("blocked_date", columns)];
   const duration = singleCase[getLabelFromTechName("zajmie_mi_to", columns)] || 0;
   const workflowImagePath =
      singleCase[getLabelFromTechName("WorkflowInstance_image_path_tdtckw", columns)];
   const casePhoto =
      workflowImagePath?.[0]?.fileUrl ?? workflowImagePath ?? singleCase?.instance_image?.url;
   const redirectPath = `/cases/${actionId}`;
   const intl = useIntl();
   const isMessageRead =
      singleCase[getLabelFromTechName("Messages_is_read_5kr0ls", columns)] ||
      singleCase[getLabelFromTechName("readed", columns)];
   const receiverType = singleCase[getLabelFromTechName("readonly_2cik5b", columns)];
   const isMessageEmail = singleCase[getLabelFromTechName("isMessageEmail", columns)];

   const resolvedMailBoxId = mailBoxId ?? 0;
   const linkToCase =
      !mailBoxId || mailBoxId === 0
         ? `/cases/${actionId}?actionId=${actionId}&mailBoxId=${resolvedMailBoxId}${isMessageEmail ? "&email=true" : ""}`
         : "#";
   const rawReceiver = singleCase?.[getLabelFromTechName("odbiorca", columns)];
   const rawGroup = singleCase?.[getLabelFromTechName("Messages_group_id_2bjybu", columns)];

   const receiver =
      typeof rawReceiver === "string"
         ? rawReceiver
         : rawReceiver?.value || String(rawReceiver) || "";
   const group =
      typeof rawGroup === "string" ? rawGroup : rawGroup?.value || String(rawGroup) || "";

   const receiverBadgeValue = receiverType
      ? receiverType === "USER"
         ? receiver
         : group
      : receiver;
   const caseStatus = getCaseStatus(start, deadlineDate, duration);

   const { dateBackground, dateText, background } = registryColors[caseStatus];

   const getStep = async () => {
      try {
         setIsLoading(true);
         const response = await getMessageStep(actionId);
         const data = response?.data?.step;
         setStep(handleActionRestrictions(data));
         setComments(data?.comments);
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false);
      }
   };

   const toggleComments = () => {
      setCommentsVisible(!commentsVisible);
   };

   const filteredInfinityListActions = () => {
      const infinityListActions: { normalButtons: any[]; systemButtons: any[] } = {
         normalButtons: [],
         systemButtons: [],
      };

      if (step?.actions) {
         infinityListActions.normalButtons = step?.actions;
      }

      if (step?.sysActions) {
         const sysActions = Object.entries(step.sysActions)
            .map(([key, actionData]) => ({
               name: key,
               ...actionData,
            }))
            .filter(
               (action) =>
                  action.name === "moveForward" ||
                  action.name === "askQuestion" ||
                  action.name === "answer",
            );

         infinityListActions.systemButtons = sysActions;
      }

      return infinityListActions;
   };

   const commentItems = React.useMemo(() => {
      return Object.values(comments ?? {});
   }, [comments]);

   const handleOpenCase = (event: React.MouseEvent) => {
      if (!isInNuxtContext()) return;
      event.preventDefault();
      const url = `/cases/${actionId}?actionId=${actionId}&mailBoxId=${resolvedMailBoxId}${isMessageEmail ? "&email=true" : ""}`;
      setUrlTo(url);
   };

   useEffect(() => {
      if (actionId) {
         getStep();
      }
   }, [actionId]);

   return (
      <MessageItemProvider
         formRef={formRef}
         currentProcessStep={step}
         setCurrentProcessStep={setStep}
      >
         <div className="single-case-wrapper" style={{ backgroundColor: background }}>
            <CaseImage
               instanceId={singleCase.instanceId}
               defaultImageUrl={casePhoto}
               className="single-case__img"
               deadlineDate={projectConfig.displayDateType === "created" ? deadlineDate : undefined}
            >
               <div className="single-case__general-info">
                  <div>
                     {projectConfig.displayDateType === "deadline" && deadlineDate && (
                        <ShowDate date={deadlineDate} dateType="deadline" />
                     )}
                     {projectConfig.displayDateType === "created" && fromDate && (
                        <ShowDate date={fromDate} dateType="created" />
                     )}
                  </div>
                  <div>
                     {rawReceiver && (
                        <div className={"single-case__title-wrapper__message-exchange"}>
                           <span>{sender?.value}</span>
                           <Icon_ArrowRight />
                           <div className="single-case__title-wrapper__message-exchange-receiver">
                              <span
                                 className={"single-case__title-wrapper__message-exchange--bold"}
                              >
                                 {receiverType === "GROUP" && (
                                    <IntlMessages id="w.newsletter.group" />
                                 )}
                                 {receiverBadgeValue}
                                 {userId == rawReceiver?.id &&
                                    (!receiverType || receiverType === "USER") && (
                                       <span
                                          className={
                                             "single-case__title-wrapper__message-exchange--bold"
                                          }
                                       >
                                          {" "}
                                          ({intl.formatMessage({ id: "case.me" })})
                                       </span>
                                    )}
                              </span>

                              <img
                                 src={!receiverType || receiverType === "USER" ? User : Group}
                                 className="single-case__title-wrapper__message-exchange-icon"
                                 alt={
                                    !receiverType || receiverType === "USER"
                                       ? intl.formatMessage({ id: "user.icon" })
                                       : intl.formatMessage({ id: "group.icon" })
                                 }
                              />
                           </div>
                        </div>
                     )}
                  </div>
               </div>
            </CaseImage>

            <main className="single-case">
               <div className="single-case__body">
                  <div className="single-case__title-wrapper">
                     <Link
                        to={linkToCase}
                        onClick={() => {
                           dispatch(setBackUrl(window.location.pathname));
                           if (isMessageRead === "0") {
                              markMessageRead(0, actionId).catch((err) => console.error(err));
                           }
                        }}
                        target="_self"
                        className={clsx(
                           "single-case__title-wrapper__title",
                           isMessageRead === "0" && "single-case__title-wrapper__title--bold",
                        )}
                        onClick={handleOpenCase}
                     >
                        {title}
                     </Link>
                  </div>

                  <TagsSection
                     tagsToDisplay={tagsToDisplay}
                     privateTagsToDisplay={privateTagsToDisplay}
                  />

                  <section className="single-case__actions">
                     <div className="single-case__actions__inner">
                        <MessageButtonsDropdown
                           /*@ts-ignore */
                           normalButtons={step?.actions}
                           /*@ts-ignore */
                           systemButtons={step?.sysActions}
                           setCurrentProcessStep={setStep}
                           windowWidth={windowWidth}
                           currentProcessStep={step}
                           sysBtnsConfig={null}
                           isQuestionMode={false}
                           inCaseActions={true}
                           buttonAsLink={true}
                           actionCallback={actionCallback}
                           displayedInInfinityList={true}
                           infinityListActions={filteredInfinityListActions()}
                           isLoadingActions={isLoading}
                           btnClassName="single-case__actions-button"
                           isSingleCaseItem={true}
                           linkToCase={linkToCase}
                        />

                        {!projectConfig.hidePlanningButtons && (
                           <PlanMessageModal
                              tags={tags}
                              privateTags={privateTags}
                              messageId={actionId}
                              start={start}
                              duration={+duration}
                              lockedDataAndTime={lockedDateAndTime}
                              lockDate={lockDate}
                              title={title}
                              deadlineDate={deadlineDate}
                              isInfiniteList={true}
                              getCases={getCases}
                              setPageToDownload={setPageToDownload}
                              areStylesBasedOnCaseStatus={true}
                           />
                        )}

                        <Button
                           className="single-case__actions__button single-case__actions__button--comment"
                           onClick={() => {
                              toggleComments();
                              setIsTextAreaFocused(true);
                           }}
                           onMouseEnter={() => setHover(true)}
                           onMouseLeave={() => setHover(false)}
                           style={{
                              backgroundColor: dateBackground,
                              color: dateText,
                              filter: hover ? "brightness(0.95)" : "none",
                           }}
                        >
                           <Icon_CommentWithDots fill={dateText} />
                        </Button>
                     </div>

                     <div className="single-case__actions__open-case-wrapper">
                        <LinkToCase linkToCase={linkToCase} onClick={handleOpenCase} />
                     </div>
                  </section>

                  {commentsVisible && (
                     <section className="single-case__comments">
                        <ScrollToBottom className="single-case__comments__scroller">
                           {!isLoading && comments ? (
                              comments.length > 0 ? (
                                 comments.map((comment) => (
                                    <CommentsItem
                                       comment={comment}
                                       key={comment?.id}
                                       scrollToFieldByTechname={null}
                                    />
                                 ))
                              ) : (
                                 <Empty
                                    description={intl.formatMessage({
                                       id: "comments.noComments",
                                    })}
                                 />
                              )
                           ) : (
                              <Spin className="single-case__comments__spinner" />
                           )}
                        </ScrollToBottom>

                        <div className="single-case__comments__add-comment-wrapper">
                           <Avatar
                              src={avatarLink}
                              alt="avatar"
                              className="single-case__comments__add-comment-wrapper__avatar"
                           />
                           <AddComments
                              /* @ts-ignore */
                              actionId={actionId}
                              customSetComments={setComments}
                              className="single-case__comments__add-comment-wrapper__add-comment"
                              focusTextArea={isTextAreaFocused}
                           />
                        </div>
                     </section>
                  )}
               </div>
            </main>
         </div>
      </MessageItemProvider>
   );
};

export default SingleCase;
